// extracted by mini-css-extract-plugin
export default {"form-section":"FormSection_form-section__e3NQT","dark":"FormSection_dark__UN7YW","form-section__wrapper":"FormSection_form-section__wrapper__Zj1tD"};